// extracted by mini-css-extract-plugin
export default {"cardino":"card_cardino__XpPcm"};